export enum VisitRoomSubmissionServiceSteps {
  Unknown = 'Unknown',
  Created = 'Created',
  PreparedResearchTopics = 'PreparedResearchTopics',
  PreparedRequestedDocuments = 'PreparedRequestedDocuments',
  InitializationDone = 'InitializationDone',
  New = 'New'
}

export enum BackofficeStatus {
  New = 'New', // Jauns
  Draft = 'Draft', // Melnraksts
  InProcess = 'InProcess', // Apstrādē
  NewRedirected = 'NewRedirected', // Jauns (pārvirzīts)
  SubmittedAdditionalInformation = 'SubmittedAdditionalInformation', //Iesnoegtas papildziņas
  RequestedAdditionalInformation = 'RequestedAdditionalInformation', //Pieprasītas papildziņas
  Approved = 'Approved', // Apstiprināts
  Rejected = 'Rejected', // Noraidīts
  Cancelled = 'Cancelled', //Atsaukts
  Unknown = 'Unknown'
}

export enum AttendenceStatus {
  Unknown = 'Unknown',
  Attended = 'Attended',
  NotAttended = 'NotAttended'
}
